// extracted by mini-css-extract-plugin
export default {"cards":"Vision_cards__g-m88","visionInner":"Vision_visionInner__tSP5O"};